module.exports = __webpack_public_path__ + "static/media/mac.dd572772.glb";